import { CancelIcon } from 'assets/icons';

export default function CancelSelectionButton({
  onClick,
}: {
  onClick: () => void;
}) {
  return (
    <div
      className="cursor-pointer hover:text-gray-dark p-1 rounded"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
    >
      <CancelIcon className="text-gray-light w-3 h-3" />
    </div>
  );
}
